import React, { useContext, PropsWithChildren } from 'react'
import { OrdersAPI5ClientCtx, RestaurantsAPI5ClientCtxx } from 'context'

import { withRouter } from 'react-router'

import { useQuery } from '@apollo/react-hooks'

import OrderV5 from 'views/order/v5'
import { GET_ORDER, Order, applyOrderAdjustmentsHierarchy as applyOrderAdjustments } from 'views/order/v5/model-order'

import { PaymentsApi } from './v5/api/payments-api'

import oauthClient from 'api/auth'
import { OrderAdjustments } from './v5//api/order-api'

const _OrderTab = require('./order-tab')
const _OrderPage = require('./order')

import { PaymentsAPI2ClientCtx } from 'context'
import { GET_ORDER_PAYMENTS } from './v5/model-payments'
import { ApolloClient } from 'apollo-boost'
import { GET_RESTAURANT_WWF, RestaurantCtx } from './v5/model-restaurant'
import { FeedbackSvc } from './v5/api/feedback'
import { Feedback2Svc } from './v5/api/feedback2'

declare let ORDERS_SVC_API5: string

function Selector(OrderComp: any) {
  return withRouter((props: any) => {
    const orderId = props.match.params.orderId
    const paymentsClient = useContext(PaymentsAPI2ClientCtx)

    const ordersClient = useContext(OrdersAPI5ClientCtx)
    if (!ordersClient || !paymentsClient) {
      return null
    }

    const orderQuery = useQuery(GET_ORDER, {
      variables: { id: orderId },
      client: ordersClient,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    })

    const paymentsQuery = useQuery(GET_ORDER_PAYMENTS, {
      variables: {
        order_id: orderId,
      },
      client: paymentsClient as ApolloClient<any>,
    })

    if (orderQuery.loading) {
      return <div>Loading order version...</div>
    }

    console.log('Rendering Selector', orderId)

    if (orderQuery.data.order.workflow_id) {
      if (orderQuery.error) {
        return (
          <div>
            <pre>{JSON.stringify(orderQuery.error, null, 2)}</pre>
          </div>
        )
      }

      const orderV5 = (
        <OrderV5
          key={props.match.params.orderId}
          order={applyOrderAdjustments(orderQuery.data.order)}
          reloadOrder={() => orderQuery.refetch({ id: orderId })}
          paymentsQuery={paymentsQuery}
          {...props}
        />
      )

      return (
        <OrderAdjustments key={orderId} svc={ORDERS_SVC_API5}>
          <PaymentsApi
            key={orderId}
            auth_token={oauthClient.getAuthResponse() ? oauthClient.getAuthResponse().access_token : null}>
            <FeedbackSvc key={orderId} orderId={orderId}>
              {OrderComp === _OrderPage ? <div className="col-9">{orderV5}</div> : orderV5}
            </FeedbackSvc>
          </PaymentsApi>
        </OrderAdjustments>
      )
    } else {
      return (
        <RestaurantAPI order={applyOrderAdjustments(orderQuery.data.order)}>
          <OrderAdjustments svc={ORDERS_SVC_API5}>
            <PaymentsApi auth_token={oauthClient.getAuthResponse() ? oauthClient.getAuthResponse().access_token : null}>
              <OrderComp
                key={orderQuery.data.order.uuid}
                order={applyOrderAdjustments(orderQuery.data.order)}
                paymentsQuery={paymentsQuery}
                {...props}
              />
            </PaymentsApi>
          </OrderAdjustments>
        </RestaurantAPI>
      )
    }
  })
}

function RestaurantAPI(props: PropsWithChildren<{ order: Order }>) {
  const restaurantClient = useContext(RestaurantsAPI5ClientCtxx)

  const restaurantQuery = useQuery(GET_RESTAURANT_WWF, {
    variables: { restaurant_id: props.order.carts.restaurant_id },
    client: restaurantClient,
  })

  if (restaurantQuery.loading || !restaurantQuery.data || !restaurantQuery.data.restaurant) {
    return null
  }

  return <RestaurantCtx.Provider value={restaurantQuery.data.restaurant}>{props.children}</RestaurantCtx.Provider>
}

export const OrderPage = Selector(_OrderPage)
export const OrderTab = Selector(_OrderTab)
